module.exports = __webpack_public_path__ + "media/images/icon_list/post-9ca4fe61f43f148295e66873c962ac73.svg";